import { URL, apiCall } from "@/utils/api";

export function getExecutives(isAdmin) {
  return apiCall({
    url: URL[process.env.NODE_ENV].auth_api + "structures/executives",
    params: { isAdmin: isAdmin },
  });
}

export function getSubOffices(isAdmin) {
  return apiCall({
    url: URL[process.env.NODE_ENV].auth_api + "structures/suboffices",
    params: { isAdmin: isAdmin },
  });
}

// fetch templates

export function getTemplates (value){
  return apiCall(
    {
      url: URL[process.env.NODE_ENV].auth_api+`messageTemplates?limit=100&offset=0&search=${value}`,

    }
  )


}
